import PanelUserManagement from '../../shared/panelUsers/PanelUserManagement';

function AdminPanelUserManagement() {
  return (
    <PanelUserManagement
      panel="admin"
      panelLabel="Admin Panel"
      subtitle="Only this gym’s admins can add users here — they can sign in only to this gym’s admin panel"
      exportSlug="admin-panel-users"
    />
  );
}

export default AdminPanelUserManagement;
